import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';

import { ACCEPTED_IMAGE_TYPES, type Attachment } from '../attachment-store.js';

interface SentAttachmentProps {
	attachment: Attachment;
}

/**
 * Read-only display of a single sent attachment. Images are rendered as a
 * thumbnail; non-image files (e.g. PDFs) are rendered as a labelled file chip.
 *
 * @param attachment - The attachment to display.
 */
export function SentAttachment({ attachment }: SentAttachmentProps) {
	if (ACCEPTED_IMAGE_TYPES.has(attachment.mediaType)) {
		return <img src={attachment.previewUrl} alt={attachment.name} className='h-16 w-16 rounded-lg object-cover' />;
	}

	return (
		<div className='flex items-center gap-1.5 rounded-lg border border-gray-a4 bg-gray-a2 px-2.5 py-1.5 text-gray-a11'>
			<ArticleOutlinedIcon style={{ fontSize: 14 }} />
			<span className='truncate max-w-[160px] text-xs'>{attachment.name}</span>
		</div>
	);
}
